import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgEditAlt(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M8.5 20c.27614 0 .5-.2239.5-.5s-.22386-.5-.5-.5v1Zm-4-.5H4c0 .2761.22386.5.5.5v-.5Zm4-.5h-4v1h4v-1Zm-3.5.5v-4H4v4h1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m8.5 19.5 9.5858-9.58579c.781-.78105.781-2.04737 0-2.82842l-1.1716-1.17158c-.781-.78104-2.0474-.78104-2.8284 0L4.5 15.5M12.5 19.5h3M16.5 11.5l-4-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAlt);

var EditAltOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { EditAltOutline as default };
